import React from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Spinner } from '@/components/ui/Spinner';

interface AddPositionsDialogShellProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  errorMessage?: string | null;
  isProcessing?: boolean;
  onCancel: () => void;
  onPrimary: () => void;
  primaryDisabled?: boolean;
  primaryText?: string;
  children?: React.ReactNode;
}

export function AddPositionsDialogShell({
  open,
  onOpenChange,
  title,
  description,
  errorMessage,
  isProcessing,
  onCancel,
  onPrimary,
  primaryDisabled,
  primaryText = 'Build Portfolio',
  children,
}: AddPositionsDialogShellProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>

        {errorMessage && (
          <div className="mb-4 p-3 bg-destructive/10 border border-destructive/30 text-destructive rounded-md text-sm">{errorMessage}</div>
        )}

        {children}

        <DialogFooter>
          <Button variant="outline" onClick={onCancel} disabled={!!isProcessing}>
            Cancel
          </Button>
          <Button onClick={onPrimary} disabled={!!primaryDisabled} className="flex items-center gap-2">
            {isProcessing ? (
              <>
                <Spinner size="sm" ariaLabel="Processing" />
                Processing...
              </>
            ) : (
              primaryText
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
